<template>
  <div class="d-flex align-items-center my-4">
    <strong>{{$t('feeds.rule')}}:</strong>
    <div v-if="this.columnName !== ''" class="d-flex align-items-center">
      <span class="ml-5 mr-4">w</span>
      <div class="custom-label bg-orange-light px-5">
        <p class="mb-0">{{ this.columnName }}</p>
      </div>
      <multiselect
        @select="onRuleTypeSelect"
        class="rule-type-multiselect mx-4"
        label="label"
        v-model="selectedRuleType"
        :allow-empty="false"
        :deselect-label="''"
        :options="ruleTypes"
        :placeholder="$t('global.select')"
        :searchable="false"
        :select-label="''"
        :selected-label="''"
        :value="this.operationType">
      </multiselect>
    </div>
    <div v-else class="ml-5 py-3"><span class="text-danger">{{ $t('feeds.rule_no_variable_found') }}</span></div>
    <div v-if="selectedRuleType.value === 'replace'" class="d-flex align-items-center w-100 replace-container">
      <input @input="onToReplaceChange" v-model="currentToReplace" class="form-control" name="ruleToReplace" type="text">
      <p class="mb-0 mx-3">na</p>
      <input @input="onReplaceWithChange" v-model="currentReplaceWith" class="form-control" name="ruleReplaceWith" type="text">
    </div>
    <div v-else-if="selectedRuleType.value === 'split nth'" class="d-flex align-items-center w-100 replace-container">
      <input @input="onToReplaceChange" v-model="currentToReplace" class="form-control" name="ruleToReplace" type="text" placeholder="separator">
      <p class="mx-4"></p>
      <input @input="onReplaceWithChange" v-model="currentReplaceWith" class="form-control" name="ruleReplaceWith" type="text" :placeholder="$t('feeds.rule_which_element')">
    </div>
    <div v-else-if="selectedRuleType.value === 'format'" class="d-flex w-100 format-container">
      <input @input="onReplaceWithChange" class="form-control" name="ruleFormat" type="text" v-model="currentReplaceWith">
      <multiselect
        @select="onSourceVariableSelect"
        class="source-variable-multiselect ml-4 mr-2"
        label="labelBracket"
        :allow-empty="false"
        :deselect-label="''"
        :options="availableSourceVariables"
        :placeholder="$t('feeds.choose_variable')"
        :searchable="true"
        :select-label="''"
        :selected-label="''">
        <template slot="option" slot-scope="props">
          <span class="option__title">{{ props.option.labelBracket }}</span>
        </template>
        <span slot="noResult">{{ $t('global.multiselect_search_not_found') }}</span>
      </multiselect>
    </div>
    <div v-else-if="selectedRuleType.value === 'regex'" class="d-flex align-items-center w-100 regex-container">
      <div class="d-flex flex-column regex-to-replace">
        <input @input="onToReplaceChange" v-model="currentToReplace" class="form-control" name="ruleToReplace" type="text">
        <p v-show="!isRegexValid" class="ml-4 mb-0 text-danger">{{ $t('feeds.rule_invalid_regex') }}</p>
      </div>
      <p class="mb-0 mx-3">-></p>
      <input @input="onReplaceWithChange" v-model="currentReplaceWith" class="form-control" name="ruleReplaceWith" type="text">
    </div>
    <div v-else-if="selectedRuleType.value === 'regex match'" class="value-container regex-container">
      <div class="d-flex flex-column regex-to-replace regex-match-to-replace">
        <input @input="onToReplaceChange" v-model="currentToReplace" class="form-control" name="ruleToReplace" type="text">
        <p v-show="!isRegexValid" class="ml-4 mb-0 text-danger">{{ $t('feeds.rule_invalid_regex') }}</p>
      </div>
    </div>
    <div v-else-if="selectedRuleType.value === 'value'" class="value-container">
      <input @input="onReplaceWithChange" v-model="currentReplaceWith" class="form-control" name="ruleValue" type="text">
    </div>
    <div v-else-if="selectedRuleType.value === 'xml'" class="value-container"></div>
    <div v-else-if="selectedRuleType.value === 'choose'" class="choose-container">
      <multiselect
        @input="onOptionSelect"
        class="mr-2 rule-option-multiselect"
        v-model="currentReplaceWith"
        :allow-empty="false"
        :deselect-label="''"
        :options="availableOptions"
        :placeholder="$t('feeds.choose_option')"
        :searchable="true"
        :select-label="''"
        :selected-label="''">
        <span slot="noResult">{{ $t('global.multiselect_search_not_found') }}</span>
      </multiselect>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import feeds from '@/mixins/feeds'

export default {
  name: 'Format',

  data () {
    return {
      currentColumnName: this.columnName,
      currentOperationType: this.operationType,
      currentReplaceWith: this.replaceWith,
      currentToReplace: this.toReplace,
      isRegexValid: true,
      selectedRuleType: ''
    }
  },

  props: {
    availableOptions: { required: false, type: Array },
    availableSourceVariables: { required: true, type: Array },
    columnName: { required: true, type: String },
    operationType: { required: true, type: String },
    replaceWith: { required: true, type: String },
    toReplace: { required: true, type: String }
  },

  mixins: [feeds],

  created () {
    if (this.operationType !== '') this.selectedRuleType = this.ruleTypes.filter(type => type.value === this.operationType)[0]
    if (this.replaceWith !== '') this.currentReplaceWith = this.replaceWith
    if (this.toReplace !== '') this.currentToReplace = this.toReplace
    if (this.availableOptions.length === 0) {
      this.ruleTypes.splice(this.ruleTypes.findIndex(ruleType => ruleType.value === 'choose'), 1)
    }
  },

  methods: {
    onRuleTypeSelect (ruleType) {
      this.currentToReplace = ''
      this.currentReplaceWith = ''
      this.$emit('onRuleTypeSelect', ruleType)
    },

    onReplaceWithChange () {
      this.$emit('onReplaceWithChange', this.currentReplaceWith)
    },

    onToReplaceChange (value) {
      if ((this.operationType === 'regex') || (this.operationType === 'regex match')) {
        const regexValidity = this.validateRegex(value.data)
        this.$emit('onRegexValidate', regexValidity)
      }
      this.$emit('onToReplaceChange', this.currentToReplace)
    },

    onSourceVariableSelect (sourceVariable) {
      this.currentReplaceWith = this.currentReplaceWith.concat('{' + sourceVariable.field + ' — ' + sourceVariable.source + '}')
      this.$emit('onReplaceWithChange', this.currentReplaceWith)
    },

    onOptionSelect () {
      this.$emit('onReplaceWithChange', this.currentReplaceWith)
    },

    validateRegex (regExp) {
      let regexValidity = true
      this.isRegexValid = true
      try {
        const newRegExp = new RegExp(regExp)
        console.log(newRegExp)
      } catch (e) {
        regexValidity = false
        this.isRegexValid = false
      }
      return regexValidity
    }
  },

  watch: {
    columnName: function () {
      const ruleTypeIndex = this.ruleTypes.findIndex(ruleType => ruleType.value === 'choose')
      if (this.availableOptions.length > 0) {
        if (ruleTypeIndex === -1) this.ruleTypes.push({ label: this.$i18n.t('operations.choose'), value: 'choose' })
        this.selectedRuleType = this.ruleTypes.filter(type => type.value === 'choose')[0]
      } else {
        this.selectedRuleType = ''
        if (ruleTypeIndex !== -1) this.ruleTypes.splice(this.ruleTypes.findIndex(ruleType => ruleType.value === 'choose'), 1)
      }
    }
  },

  components: { Multiselect }
}
</script>
